export const newsData = [
  {
    id: 15,
    title: "¿Cómo llegar a Imperio TEA?",
    description:
      "Te mostramos la ruta para llegar fácilmente a nuestras instalaciones en La Calera, Valparaíso.",
    content:
      "Nuestra dirección es Arturo Pérez Canto #612, La Calera, Valparaíso. Revisa el video para reconocer el recorrido y ubicar nuestra sede con mayor facilidad. ¡Te esperamos!",
    date: "2026-08-25",
    type: "Información",
    image: "/images/activities/como-llegar-imperio-tea.webp",
    video: "/videos/como-llegar-imperio-tea.mp4",
    link: "/news/15",
    alt: "Vista de la ruta para llegar a las instalaciones de Corporación Imperio TEA.",
  },
  {
    id: 14,
    title: "Día de la Niñez 2026",
    description:
      "Celebramos a nuestros niños y niñas con una entretenida jornada llena de regalos, sonrisas y momentos para compartir.",
    content:
      "En Corporación Imperio TEA celebramos el Día de la Niñez junto a nuestra comunidad. Fue una jornada de alegría, cariño y sorpresas, donde cada niño y niña recibió un regalo preparado especialmente para esta fecha.\n\nAgradecemos a las familias por acompañarnos y permitirnos seguir construyendo espacios de inclusión, respeto y felicidad.",
    date: "2026-08-16",
    type: "Actividad",
    image: "/images/activities/dia-ninez-2026/07.webp",
    imageCollage: [
      "/images/activities/dia-ninez-2026/01.webp",
      "/images/activities/dia-ninez-2026/02.webp",
      "/images/activities/dia-ninez-2026/03.webp",
      "/images/activities/dia-ninez-2026/04.webp",
      "/images/activities/dia-ninez-2026/05.webp",
      "/images/activities/dia-ninez-2026/06.webp",
      "/images/activities/dia-ninez-2026/07.webp",
      "/images/activities/dia-ninez-2026/08.webp",
      "/images/activities/dia-ninez-2026/09.webp",
      "/images/activities/dia-ninez-2026/10.webp",
      "/images/activities/dia-ninez-2026/11.webp",
      "/images/activities/dia-ninez-2026/12.webp",
      "/images/activities/dia-ninez-2026/13.webp",
      "/images/activities/dia-ninez-2026/14.webp",
      "/images/activities/dia-ninez-2026/15.webp",
      "/images/activities/dia-ninez-2026/16.webp",
      "/images/activities/dia-ninez-2026/17.webp",
      "/images/activities/dia-ninez-2026/18.webp",
      "/images/activities/dia-ninez-2026/19.webp",
      "/images/activities/dia-ninez-2026/20.webp",
    ],
    link: "/news/14",
    alt: "Niño sonriendo mientras sostiene un regalo preparado para la celebración del Día de la Niñez en Corporación Imperio TEA.",
  },
  {
    id: 1,
    title: "Dia del niño",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/dia-niño/Dia-niño3.webp",
    imageCollage: [
      "/images/activities/dia-niño/Dia-niño1.webp",
      "/images/activities/dia-niño/Dia-niño2.webp",
      "/images/activities/dia-niño/Dia-niño3.webp",
      "/images/activities/dia-niño/Dia-niño4.webp",
      "/images/activities/dia-niño/Dia-niño5.webp",
      "/images/activities/dia-niño/Dia-niño6.webp",
      "/images/activities/dia-niño/Dia-niño7.webp",
      "/images/activities/dia-niño/Dia-niño8.webp",
    ],
    link: "/news/1",
    alt: "Dos personas disfrazadas de Minnie y Mickey Mouse junto a un banner de 'Imperio TEA' que promueve apoyo para niños y jóvenes con trastorno del espectro autista y sus familias, con información de contacto y una imagen de manos pintadas.",
  },
  {
    id: 2,
    title: "Fiestas patrias",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/fiestas-patrias/fiestas-patrias4.webp",
    imageCollage: [
      "/images/activities/fiestas-patrias/fiestas-patrias1.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias2.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias3.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias4.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias5.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias6.webp",
      "/images/activities/fiestas-patrias/fiestas-patrias7.webp",
    ],
    link: "/news/2",
    alt: "Dos personas celebrando Fiestas Patrias frente a una mesa decorada con un mantel rojo y blanco, con banderas chilenas y elementos de asado. Una persona lleva un delantal con la bandera de Chile y la otra lleva un vestido tradicional chileno de color rosa con blanco.",
  },
  {
    id: 3,
    title: "Taller de equinoterapia",
    content: "",
    date: "2024-06-10",
    type: "Taller",
    image: "/images/activities/taller-equinoterapia/taller-equino4.webp",
    imageCollage: [
      "/images/activities/taller-equinoterapia/taller-equino1.webp",
      "/images/activities/taller-equinoterapia/taller-equino2.webp",
      "/images/activities/taller-equinoterapia/taller-equino3.webp",
      "/images/activities/taller-equinoterapia/taller-equino4.webp",
      "/images/activities/taller-equinoterapia/taller-equino5.webp",
      "/images/activities/taller-equinoterapia/taller-equino6.webp",
    ],
    link: "/news/3",
    alt: "Un niño montando a caballo durante una sesión de equinoterapia, con un casco de seguridad y una manta sobre el caballo.",
  },
  {
    id: 4,
    title: "Dia mundial de la concienciación del autismo",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/Dia-mundial-autismo/dia-autismo4.webp",
    imageCollage: [
      "/images/activities/Dia-mundial-autismo/dia-autismo1.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo2.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo3.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo4.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo5.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo6.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo7.webp",
      "/images/activities/Dia-mundial-autismo/dia-autismo8.webp",
    ],
    link: "/news/4",
    alt: "Un stand decorado con globos y banderines para el Día Mundial del Autismo, con un banner de 'Imperio TEA' que muestra figuras de niños hechos con piezas de rompecabezas y el texto 'Apoyamos a niños, niñas y jóvenes diagnosticados con trastorno del espectro autista y a sus familias', y una mesa con materiales informativos.",
  },
  {
    id: 5,
    title: "Proyecto Anglo American",
    content: "",
    date: "2024-06-10",
    type: "Charla",
    image: "/images/activities/anglo-american/anglo1.webp",
    imageCollage: [
      "/images/activities/anglo-american/anglo1.webp",
      "/images/activities/anglo-american/anglo2.webp",
      "/images/activities/anglo-american/anglo3.webp",
    ],
    link: "/noticias/1",
    alt: "Un grupo de personas posando juntas en una sala, con un banner de 'Imperio TEA' en el fondo que promueve apoyo para niños con autismo, y una mesa con algunos objetos en primer plano.",
  },
  {
    id: 6,
    title: "Proyecto Banco estado",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/banco-estado/banco-estado4.webp",
    imageCollage: [
      "/images/activities/banco-estado/banco-estado1.webp",
      "/images/activities/banco-estado/banco-estado2.webp",
      "/images/activities/banco-estado/banco-estado3.webp",
      "/images/activities/banco-estado/banco-estado4.webp",
      "/images/activities/banco-estado/banco-estado5.webp",
    ],
    link: "/noticias/1",
    alt: "Una mesa con varios juguetes educativos y de destreza, incluyendo rompecabezas, instrumentos musicales como maracas y xilófonos, y cajas de juegos como torres de apilamiento y actividades de ensartar.",
  },
  {
    id: 7,
    title: "Curso primeros auxilios",
    content: "",
    date: "2024-06-10",
    type: "Charla",
    image: "/images/activities/curso-auxilio/curso-auxilio3.webp",
    imageCollage: [
      "/images/activities/curso-auxilio/curso-auxilio1.webp",
      "/images/activities/curso-auxilio/curso-auxilio2.webp",
      "/images/activities/curso-auxilio/curso-auxilio3.webp",
    ],
    link: "/noticias/1",
    alt: "Un grupo de personas posando frente a un banner de 'Imperio TEA' en una sala con techo alto y paneles de madera en la pared, con uno de ellos vestido con un chaleco reflectante.",
  },
  {
    id: 8,
    title: "Taller 7% fondo nacional del desarrollo",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/taller-fondoNacional/fondoNacional4.webp",
    imageCollage: [
      "/images/activities/taller-fondoNacional/fondoNacional1.webp",
      "/images/activities/taller-fondoNacional/fondoNacional2.webp",
      "/images/activities/taller-fondoNacional/fondoNacional3.webp",
      "/images/activities/taller-fondoNacional/fondoNacional4.webp",
    ],
    link: "/noticias/1",
    alt: "Un niño corriendo sobre una serie de conos de colores dispuestos en el suelo, mientras varias personas observan desde el fondo en un patio al atardecer.",
  },
  {
    id: 9,
    title: "Salida recreativa, Parque Sayayin",
    content: "",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/parque-sayayin.webp",
    link: "/noticias/1",
    alt: "Un grupo de personas sentadas en sillas de plástico bajo una carpa, con globos de colores en el fondo y un letrero que dice 'Sayayin Entreteniciones'.",
  },
  {
    id: 10,
    title: "Charla en conjunto con CFTPUCV",
    content:
      "En esta charla, se abordaron temas relacionados con el trastorno del espectro autista, como la importancia de la detección temprana y el papel de la familia en el proceso de diagnóstico y tratamiento. Se destacó la importancia de la comprensión y la aceptación de las personas con autismo, y se presentaron experiencias de vida de personas con autismo que han logrado superar los desafíos y alcanzar sus objetivos.\n\nTambién se habló sobre la importancia de la inclusión y el respeto hacia las personas con discapacidad, y se presentaron ejemplos de cómo se puede lograr una mayor inclusión en diferentes ámbitos de la sociedad.",
    date: "2024-06-10",
    type: "Actividad",
    image: "/images/activities/charla-cftpucv/cftpucv10.webp",
    imageCollage: [
      "/images/activities/charla-cftpucv/cftpucv1.webp",
      "/images/activities/charla-cftpucv/cftpucv2.webp",
      "/images/activities/charla-cftpucv/cftpucv3.webp",
      "/images/activities/charla-cftpucv/cftpucv4.webp",
      "/images/activities/charla-cftpucv/cftpucv5.webp",
      "/images/activities/charla-cftpucv/cftpucv6.webp",
      "/images/activities/charla-cftpucv/cftpucv7.webp",
      "/images/activities/charla-cftpucv/cftpucv8.webp",
      "/images/activities/charla-cftpucv/cftpucv9.webp",
    ],
    link: "/noticias/1",
    alt: "Un grupo grande de personas posando para una foto en una sala con paredes amarillas, con banderas chilenas en el fondo, una mesa con un equipo de sonido y un banner de 'CFTPUCV'.",
  },
  {
    id: 11,
    title: "Una Pascua Dulce con Imperio Tea 2025",
    content:
      'En Imperio Tea, la Pascua de Resurrección 2025 fue una celebración llena de cariño y dulzura. Queríamos sorprender a nuestra comunidad, por eso preparamos un obsequio especial: conejitos y huevitos de Pascua que llenaron de alegría esta fecha tan significativa. Gracias al entusiasmo y apoyo de nuestros queridos "Tíos" y "Tías", logramos compartir estos detalles con todos, creando momentos inolvidables. Esperamos que cada sonrisa y cada bocado hayan hecho de este día una experiencia única. ¡En Imperio Tea, celebramos la Pascua con amor y sabor!',
    date: "2025-04-20",
    type: "Actividad",
    image: "/images/activities/pascua/File8.webp",
    imageCollage: [
      "/images/activities/pascua/File1.webp",
      "/images/activities/pascua/File2.webp",
      "/images/activities/pascua/File3.webp",
      "/images/activities/pascua/File4.webp",
      "/images/activities/pascua/File5.webp",
      "/images/activities/pascua/File6.webp",
      "/images/activities/pascua/File7.webp",
      "/images/activities/pascua/File8.webp",
      "/images/activities/pascua/File9.webp",
      "/images/activities/pascua/File10.webp",
      "/images/activities/pascua/File11.webp",
      "/images/activities/pascua/File12.webp",
    ],
    link: "/noticias/1",
    alt: "Niño y adulto sonriendo con orejas de conejo, sosteniendo una bolsa de dulces de Pascua con conejitos y huevitos, en un ambiente colorido y festivo.",
  },
  {
    id: 12,
    title: "Navidad 2025",
    content:
      "Al cerrar este año, queremos agradecer la confianza de los padres y el compromiso de nuestro equipo profesional. Pero, sobre todo, celebramos la magia única de cada niño que forma parte de nuestra corporación. Que este nuevo año sea una oportunidad para seguir creciendo en un mundo más comprensivo e inclusivo.Que el 2026 sigan sumando nuevos logros y celebrando cada paso juntos! 🎄✨ ¡Felices Fiestas les desea Corporación Imperio TEA! 💙",
    date: "2025-12-24",
    type: "Mensaje",
    image: "/images/activities/navidad.webp",
    link: "/noticias/1",
    alt: "Grupo de profesionales de Imperio TEA posando para una foto festiva, con gorros de Navidad y sonrisas, en un ambiente decorado con motivos navideños.",
  },
  {
    id: 13,
    title: "Año nuevo 2025",
    content:
      "Como corporacion, nos sentimos orgullosos de nuestros profesionales. En estas fechas de celebración, queremos reconocer la labor que cada uno de ellos desempeña hacia nuest@s niñ@s. FELICADES EN ESTAS FIESTAS.",
    date: "2025-12-29",
    type: "Mensaje",
    image: "/images/activities/new-year/new1.webp",
    imageCollage: [
      "/images/activities/new-year/new1.webp",
      "/images/activities/new-year/new2.webp",
      "/images/activities/new-year/new3.webp",
      "/images/activities/new-year/new4.webp",
    ],
    link: "/noticias/1",
    alt: "Grupo de profesionales de Imperio TEA posando para una foto festiva, con gorros de Navidad y sonrisas, en un ambiente decorado con motivos navideños.",
  },
];
